import { useSelector } from 'react-redux';

import { selectPlanCharacteristics } from '@app/redux';
import { isUnleashedFamily } from '@app/utils';

export const useShowUnleashedUsage = () => {
  const {
    characteristics: { name, productFamily },
  } = useSelector(selectPlanCharacteristics);

  return isUnleashedFamily(productFamily, name);
};
